import { Stack, Box, useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormField from './FormField';
import QuestionLabel from './QuestionLabel';
import { fieldSx } from './formTheme';
import { useTranslation } from 'react-i18next';

export default function SuspensionForm() {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const suspensionInterest = watch('bodySuspension.suspensionInterest');
  const jointSuspension = watch('bodySuspension.jointSuspension');

  const yesNo = [
    { label: t('yes'), value: 'TAK' },
    { label: t('no'), value: 'NIE' },
  ];

  const fields = [
    {
      type: 'radio',
      label: t('suspension_interest'),
      name: 'bodySuspension.suspensionInterest',
      options: yesNo,
    },
  ];

  if (suspensionInterest === 'TAK') {
    fields.push(
      {
        type: 'radio',
        label: t('first_time_suspension'),
        name: 'bodySuspension.firstTimeSuspension',
        options: yesNo,
      },
      {
        type: 'text',
        label: t('suspension_position'),
        name: 'bodySuspension.suspensionPosition',
        alternateLabel: true,
      },
      {
        type: 'radio',
        label: t('joint_suspension'),
        name: 'bodySuspension.jointSuspension',
        options: yesNo,
      },
    );

    if (jointSuspension === 'TAK') {
      fields.push({
        type: 'text',
        label: t('joint_suspension_partner'),
        name: 'bodySuspension.jointSuspensionPartner',
      });
    }

    fields.push(
      {
        type: 'radio',
        label: t('privacy_preference'),
        name: 'bodySuspension.privacyPreference',
        alternateLabel: jointSuspension === 'TAK',
        options: [
          { label: t('public'), value: 'public' },
          { label: t('private'), value: 'private' },
        ],
      },
      {
        type: 'textarea',
        label: t('suspension_intention'),
        name: 'bodySuspension.suspensionIntention',
        alternateLabel: true,
      },
      {
        type: 'textarea',
        label: t('suspension_vision'),
        name: 'bodySuspension.suspensionVision',
        alternateLabel: true,
      },
      {
        type: 'textarea',
        label: t('suspension_health_info'),
        name: 'bodySuspension.suspensionHealthInfo',
        alternateLabel: true,
      },
    );
  }

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          flexWrap: 'wrap',
          gap: 4,
        }}
      >
        <Box>
          <p>{t('suspension_intro')}</p>
        </Box>
        {fields.map((field) => (
          <Box key={field.name} sx={fieldSx(field, mobileScreen)}>
            <QuestionLabel
              component='label'
              sx={{ mb: 1, color: 'rgba(255,255,255,0.8)' }}
              collapsible={!(field.alternateLabel || mobileScreen)}
            >
              {field.label}
            </QuestionLabel>
            <FormField
              {...field}
              label={null}
              ariaLabel={
                typeof field.label === 'string' ? field.label : undefined
              }
              register={register}
              error={errors?.bodySuspension?.[field.name.split('.')[1]]}
              helperText={
                errors?.bodySuspension?.[field.name.split('.')[1]]?.message
              }
              fullWidth
            />
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
